import React from 'react';
import cls from 'classnames';

import { useRoutes } from 'src/explore/hooks/useRoutes';
import { IMerchant } from 'src/explore/types/shoppe';

import { Accolades } from './compositions/Accolades';

interface MerchantAttributionProps {
  attribution?: string;
  className?: string;
  hideStarShipper?: boolean;
  merchant: Pick<IMerchant, 'loveScore' | 'name' | 'permalink' | 'starShipper'>;
}

export const MerchantAttribution = ({
  attribution = '',
  className,
  hideStarShipper,
  merchant: { loveScore, name, permalink, starShipper },
}: MerchantAttributionProps ) => {
  const routes = useRoutes();

  return (
    <div
      className={cls( 'ff-cabin text-decoration-none font-weight-normal d-flex flex-row', className )}
    >
      {`${attribution} `}
      <a
        className="flex-fill mr-4 text-secondary font-weight-bold text-decoration-none spec__product-merchant"
        href={routes.merchant( permalink )}
        id={permalink}
        itemProp="brand"
      >
        {name}
      </a>

      <Accolades loveScore={loveScore} starShipper={hideStarShipper ? false : starShipper} />
    </div>
  );
};
